import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { DataTableDirective } from 'angular-datatables';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ProiectePushNotificationsService } from './proiecte-push-notifications.service';
import { ViewPushNotificationComponent } from './view-push-notification/view-push-notification.component';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'app-proiecte-push-notifications',
    templateUrl: './proiecte-push-notifications.component.html',
    styleUrls: ['./proiecte-push-notifications.component.scss']
})
export class ProiectePushNotificationsComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;

    isLoading = false;
    showCard = false;

    // Popover dates
    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;
    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(2022, 6, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = '';

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Dată adăugat' },
        { id: 2, value: 'Dată actualizat' },
        { id: 3, value: 'Dată Procesare' },
    ];

    statuses: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Active', value: 1 },
        { key: 'Inactive', value: 0 },
    ]

    types: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        // { key: 'Push Notification', value: 1 },
        // { key: 'Sondaje', value: 2 },
        // { key: 'Sesizare', value: 3 },
        // { key: 'Noutăți', value: 4 },
        // { key: 'Plăți', value: 5 },
        // { key: 'Registratura DMU', value: 6 },
        { key: 'Proiecte', value: 7 },
    ]

    processedStatuses: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Pending', value: 0 },
        { key: 'Pending Procesare', value: 1 },
        { key: 'Procesat', value: 2 },
        { key: 'Eroare Procesare Terț', value: 3 },
        { key: 'Fără Device-uri', value: 4 },
    ]

    possibleSubs: { [key: number]: { value: number; key: string }[] } = {
        [-1]: [{ value: -1, key: '-- Alegeți --' }],
        // [1]: [{ value: -1, key: '-- Alegeți --' }], // push General
        // [2]: [ // sondaj
        //     { value: -1, key: '-- Alegeți --' },
        //     { value: 1, key: 'Push în masă' },
        //     { value: 2, key: 'Felicitări/Participare' },
        //     { value: 3, key: 'Închidere Sondaj' },
        // ],
        // [3]: [ // sesizare
        //     { value: -1, key: '-- Alegeți --' },
        //     { value: 1, key: 'Nou' },
        //     { value: 2, key: 'Preluată' },
        //     { value: 3, key: 'Finalizată' },
        // ],
        // [4]: [{ value: -1, key: '-- Alegeți --' }], // noutati
        // [5]: [ // plati
        //     { value: -1, key: '-- Alegeți --' },
        //     { value: 0, key: 'Verifică plățile / Început de an' },
        //     { value: 1, key: 'Felicitări pentru plată' },
        // ],
        // [6]: [ // registratura dmu
        //     { value: -1, key: '-- Alegeți --' },
        //     { value: 1, key: 'Nou' },
        //     { value: 2, key: 'Preluată' },
        //     { value: 3, key: 'Finalizată' },
        // ],
        [7]: [
            { value: -1, key: '-- Alegeți --' },
            { value: 1, key: 'Alocat' },
            { value: 2, key: 'Mesaj intern' },
        ],
    };

    dateFilterOption: string = '1';

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    }

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = environment.interop.basePath + environment.interop.monitoring.pushNotifications.listDT;

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        active: -1,
        public_view: -1,
        type: -1,
        param_sub_id: -1,
        processed: -1,
        param_id: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            active: new FormControl(-1),
            public_view: new FormControl(-1),
            type: new FormControl(-1),
            param_sub_id: new FormControl(-1),
            processed: new FormControl(-1),
            param_id: new FormControl(''),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT();
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private proiectePushNotificationsService: ProiectePushNotificationsService,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.renderDT();
        this.buildSearchParamsForm();

        this.searchParamsForm.get('type')?.valueChanges.subscribe(() => {
            this.updateSubOptions();
        });
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    updateSubOptions() {
        const selectedType = this.searchParamsForm.get('type')?.value;
        this.searchParamsForm.get('param_sub_id')?.setValue(-1); // Reset sub-tip selection
        this.possibleSubs = {
            ...this.possibleSubs,
            [selectedType]: this.getSubOptions(selectedType)
        };
    }

    getSubOptions(selectedType: number) {
        return this.possibleSubs[selectedType] || [];
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 10,
            order: [[0, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                Object.assign(dataTablesParameters, this.searchParamsForm.value);
                dataTablesParameters.tip_date = parseInt(this.dateFilterOption, 10);
                dataTablesParameters.date_from = this.formatDate(this.selectedStartDate);
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        })
                    })
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '5%', targets: 0 },
                { width: '23%', targets: 1 },
                { width: '5%', targets: 2 },
                { width: '5%', targets: 3 },
                { width: '5%', targets: 4 },
                { width: '7%', targets: 5 },
                { width: '10%', targets: 6 },
                { width: '10%', targets: 7 },
                { width: '10%', targets: 8 },
                { width: '20%', targets: 9 },
            ],
            columns: [
                {
                    title: 'ID',
                    data: 'id_push',
                },
                {
                    title: 'Titlu',
                    data: 'title',
                },
                {
                    title: 'Tip',
                    data: 'type_lbl',
                    sortable: false,
                },
                {
                    title: 'Activ',
                    data: 'active',
                    sortable: false,
                },
                {
                    title: 'Publicat',
                    data: 'public_view',
                    sortable: false,
                },
                {
                    title: 'Procesat',
                    data: 'processed',
                    sortable: false,
                },
                {
                    title: 'Adăugat',
                    data: 'created_at',
                },
                {
                    title: 'Actualizat',
                    data: 'updated_at',
                },
                {
                    title: 'Programat',
                    data: 'schedule_date',
                },
                {
                    title: 'Sumar',
                    data: 'summary',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        // Regular expression to match numbers within <span> tags
                        const regex = /<span>\s*(\d+)\s*<\/span>/g;
                        const numbers: number[] = [];
                        let match;

                        // Extract numbers from HTML using regex
                        while ((match = regex.exec(data)) !== null) {
                            const number = parseInt(match[1]);
                            numbers.push(number);
                        }

                        return `
                            <div class="d-flex flex-row justify-content-center align-items-center w-100">
                                <div title="Unici" class="d-flex flex-grow-1 align-items-center" style="font-size: 120%; font-weight: 600;">
                                    <i class="fa fa-users me-1" style="color: red;"></i>
                                    <span>${numbers[0]}</span>
                                </div>

                                <div title="Total Vizualizări" class="d-flex flex-grow-1 align-items-center" style="font-size: 120%; font-weight: 600;">
                                    <i class="fa fa-eye me-1" style="color: blue;"></i>
                                    <span>${numbers[1]}</span>
                                </div>

                                <div title="Device-uri Android" class="d-flex flex-grow-1 align-items-center" style="font-size: 120%; font-weight: 600;">
                                    <i class="fa-brands fa-android me-1" style="color: #06b706;"></i>
                                    <span>${numbers[2]}</span>
                                </div>

                                <div title="Device-uri IOS" class="d-flex flex-grow-1 align-items-center" style="font-size: 120%; font-weight: 600;">
                                    <i class="fa-brands fa-apple me-1" style="color: #949090;"></i>
                                    <span>${numbers[3]}</span>
                                </div>
                            </div>
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
        };
    }

    onRowClick(rowData: Request) {
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });

        this.closePopover();
    }

    openInfoDialog(data: any) {
        const dialogRef = this.dialog.open(ViewPushNotificationComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                pushNotification: data,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
        });
    }
}
